module.exports = __webpack_public_path__ + "static/media/0012.7d293b76.jpg";